import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { db, doc, addDoc, collection, deleteDoc } from "../../../firebase";
import { setDoc } from "firebase/firestore";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import ConfirmDialog from "../../ConfirmDialog";

import { useAuth } from "../../../context/AuthContext";
import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";

const Address = () => {
	const [confirmDialog, setConfirmDialog] = useState(false);
	const { getAddresses, getFirstname, getLastname, currentUser } = useAuth();
	const [allAddresses, setAllAddresses] = useState([]);

	const [addressId, setAddressId] = useState(null);
	const [fn, setFn] = useState("");
	const [ln, setLn] = useState("");
	const [address, setAddress] = useState("");
	const [apt, setApt] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [zipcode, setZipcode] = useState("");

	const [open, setOpen] = React.useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		setAllAddresses(getAddresses());
	}, [getAddresses]);

	const resetAddress = () => {
		setFn("");
		setLn("");
		setAddress("");
		setApt("");
		setCity("");
		setState("");
		setZipcode("");
		setAddressId(null);
	};
	const addNewAddress = () => {
		resetAddress();
		setOpen(true);
	};
	const handleClickOpen = (
		addfn,
		addln,
		addadd,
		addapt,
		addcity,
		addstate,
		addzipcode,
		addId
	) => {
		setFn(addfn);
		setLn(addln);
		setAddress(addadd);
		setApt(addapt);
		setCity(addcity);
		setState(addstate);
		setZipcode(addzipcode);
		setAddressId(addId);
		setOpen(true);
	};
	const removeAddress = async () => {
		try {
			await deleteDoc(doc(db, "users", currentUser.uid, "address", addressId));
		} catch (error) {
			setError(
				"There is a technical issue. We are very sorry about inconvenience. Try later."
			);
			console.log(error);
		}
	};

	const handleSaveChange = async () => {
		let readyToSubmit = true;
		if (fn.length === 0) {
			setFn(getFirstname());
		}
		if (ln.length === 0) {
			setLn(getLastname());
		}
		if (!zipcode || zipcode.length === 0) {
			setError("Please put zipcode.");
			readyToSubmit = false;
		}
		if (!state || state.length === 0) {
			setError("Please put state.");
			readyToSubmit = false;
		}
		if (!city || city.length === 0) {
			setError("Please put city.");
			readyToSubmit = false;
		}
		if (!address || address.length === 0) {
			setError("Please put address.");
			readyToSubmit = false;
		}

		if (readyToSubmit && addressId) {
			// Modify the current address
			try {
				await setDoc(doc(db, "users", currentUser.uid, "address", addressId), {
					firstname: fn,
					lastname: ln,
					address: address,
					apt: "#" + apt,
					city: city,
					state: state,
					zipcode: zipcode,
				});
			} catch (error) {
				console.log(error);
			}
		} else if (readyToSubmit && !addressId) {
			// Add a new address
			try {
				const docRef = await addDoc(
					collection(db, "users", currentUser.uid, "address"),
					{
						firstname: fn,
						lastname: ln,
						address: address,
						apt: "#" + apt,
						city: city,
						state: state,
						zipcode: zipcode,
					}
				);
				console.log("Document written with ID: ", docRef.id);
			} catch (error) {
				console.log(error);
			}
		}
	};

	const handleClose = () => {
		setOpen(false);
	};
	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Address</DialogTitle>
				<DialogContent>
					<DialogContentText>Change your address here.</DialogContentText>

					{/* <AddressForm /> */}
					<Box>{error && <Alert severity="warning">{error}</Alert>}</Box>
					<TextField
						autoFocus
						margin="dense"
						id="firstname"
						label="First name"
						type="email"
						fullWidth
						variant="filled"
						value={fn}
						onChange={(e) => setFn(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="Last name"
						type="text"
						fullWidth
						variant="filled"
						value={ln}
						onChange={(e) => setLn(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="Address"
						type="email"
						fullWidth
						variant="filled"
						value={address}
						onChange={(e) => setAddress(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="Apt #"
						type="email"
						fullWidth
						variant="filled"
						value={apt}
						onChange={(e) => setApt(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="City"
						type="email"
						fullWidth
						variant="filled"
						value={city}
						onChange={(e) => setCity(e.target.value)}
					/>
					<TextField
						margin="dense"
						id="name"
						label="State"
						type="email"
						v
						fullWidth
						variant="filled"
						value={state}
						sx={{ textTransform: "uppercase" }}
						onChange={(e) => setState(e.target.value.toUpperCase())}
					/>
					<TextField
						margin="dense"
						id="name"
						label="Zipcode"
						type="email"
						fullWidth
						variant="filled"
						value={zipcode}
						onChange={(e) => setZipcode(e.target.value)}
						inputProps={{ maxLength: 5 }}
					/>
				</DialogContent>
				<DialogActions sx={{ pb: 3, pr: 3 }}>
					<button
						className="custom_btn_whitebg"
						style={{ width: "100px" }}
						onClick={handleClose}
					>
						Cancel
					</button>
					{addressId && (
						<button
							className="custom_btn_whitebg"
							style={{ width: "200px" }}
							onClick={() => setConfirmDialog(true)}
						>
							Remove address
						</button>
					)}
					<button
						className="custom_btn"
						style={{ width: "160px", fontSize: "13px" }}
						onClick={handleSaveChange}
					>
						Save Changes
					</button>
				</DialogActions>
			</Dialog>
			{confirmDialog ? <ConfirmDialog agree={removeAddress} /> : null}
			<Box sx={{ pt: 5, fontSize: "23px", pb: 3 }}>Addresses</Box>
			<Box sx={{ display: "flex" }}>
				<button
					className="custom_btn_whitebg"
					style={{
						width: "200px",
						height: "250px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={addNewAddress}
				>
					Add Address
					<AddIcon />
				</button>

				{allAddresses?.map((add) => (
					<button
						className="custom_btn_whitebg"
						style={{
							width: "200px",
							height: "250px",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							marginLeft: "20px",
							marginRight: "20px",
							lineHeight: "1.4em",
						}}
						onClick={() =>
							handleClickOpen(
								add.firstname,
								add.lastname,
								add.address,
								add.apt,
								add.city,
								add.state,
								add.zipcode,
								add.id
							)
						}
					>
						<span style={{ color: "black", fontWeight: "bold" }}>
							{add.firstname && add.firstname}
						</span>
						<span style={{ color: "black", fontWeight: "bold" }}>
							{add.lastname && add.lastname}
						</span>

						<br />
						{add.address && add.address}
						<br />
						{add.apt && add.apt}
						{add.apt && <br />}
						{add.city && add.city}
						<br />
						{add.state && add.state}
						<br />
						{add.state && add.zipcode}
						<CreateIcon />
					</button>
				))}
			</Box>
		</div>
	);
};

export default Address;
